<div class="container text-center">
  <h1 class="mb-5">Resultado de la suscripción</h1>

  <div *ngIf="this.loading" class="text-center">
    Cargando...
  </div>

  <div *ngIf="this.error" [innerHTML]="this.error" class="errors-container mt-3 alert alert-danger" role="alert"></div>
  <div *ngIf="this.message" [innerHTML]="this.message" class="messages-container mt-3 alert alert-success" role="alert"></div>
  <div *ngIf="this.error" class="text-center">
    <button type="button" class="use-app-colors btn btn-lg btn-primary mt-3" (click)="this.goTo('planes')">Ver todos los planes</button>
  </div>
</div>
